import { AxiosError } from 'axios'

/**
 * Checks if an Axios error indicates that the server is in maintenance mode.
 *
 * @param error - The Axios error to check
 * @returns true if the server is in maintenance mode (status 903), false otherwise
 *
 * @example
 * try {
 *   await axios.get('/api/data')
 * } catch (error) {
 *   if (isMaintenanceError(error)) {
 *     // Handle maintenance mode
 *   }
 * }
 */
export const isMaintenanceError = (error: AxiosError): boolean => {
  if (!error?.response) return false
  return error.response.status === 903
}
